import apiClient from "./api";

const INVENTARIO_API_BASE_URL = "/inventarios";

class InventariosService {
    async getInventario(idSucursal) {
        try {
            const url = idSucursal && idSucursal !== "todas"
                ? `${INVENTARIO_API_BASE_URL}?idSucursal=${idSucursal}`
                : INVENTARIO_API_BASE_URL;
            const res = await apiClient.get(url);
            if (res.data && res.data.articulos) {
                return res.data;
            }
        } catch (err) {
            console.warn("Backend /inventarios no disponible o falló; usando almacenamiento local de respaldo.", err?.message);
        }
    }

    async agregarArticulo(payload) {
        // payload: { nombre, stockMinimo, sucursales: [id1, id2], relacionesEstudios: [{ idEstudio, consumo }] }
        try {
            const res = await apiClient.post(INVENTARIO_API_BASE_URL, payload);
            if (res.data && res.data.estatus === "OK") {
                return res.data;
            }
        } catch (err) {
            console.warn("Backend POST /inventarios no disponible o falló.", err?.message);
            return { estatus: "ERROR", mensaje: err?.message || "Error al agregar artículo" };
        }
    }

    async deleteArticulo(idArticulo) {
        try {
            const res = await apiClient.delete(`${INVENTARIO_API_BASE_URL}/${idArticulo}`);
            if (res.data && res.data.estatus === "OK") {
                return res.data;
            }
        } catch (err) {
            console.warn(`Backend DELETE /inventarios/${idArticulo} no disponible; usando respaldo local.`, err?.message);
            return { estatus: "ERROR", mensaje: err?.message || "Error al eliminar artículo" };
        }
    }

    async registrarEntrada(payload) {
        // payload: { idArticulo, cantidad, motivo, idUsuario, idSucursal }
        try {
            const res = await apiClient.post(`${INVENTARIO_API_BASE_URL}/movimientos/entrada`, payload);
            if (res.data && res.data.estatus === "OK") {
                return res.data;
            }
        } catch (err) {
            console.warn("Backend POST /inventarios/movimientos/entrada no disponible.", err?.message);
            return { estatus: "ERROR", mensaje: err?.message || "Error al registrar entrada" };
        }
    }

    async registrarSalida(payload) {
        // payload: { idArticulo, cantidad, motivo, idUsuario, idSucursal }
        try {
            const res = await apiClient.post(`${INVENTARIO_API_BASE_URL}/movimientos/salida`, payload);
            if (res.data && res.data.estatus === "OK") {
                return res.data;
            }
        } catch (err) {
            console.warn("Backend POST /inventarios/movimientos/salida no disponible.", err?.message);
            return { estatus: "ERROR", mensaje: err?.message || "Error al registrar salida" };
        }
    }

    async registrarSalidaEstudio(payload) {
        // payload: { idArticulo, cantidad, idEstudio, motivo, idUsuario, idSucursal }
        try {
            const res = await apiClient.post(`${INVENTARIO_API_BASE_URL}/movimientos/salida/estudio`, payload);
            if (res.data && res.data.estatus === "OK") {
                return res.data;
            }
        } catch (err) {
            console.warn("Backend POST /inventarios/movimientos/salida/estudio no disponible.", err?.message);
            return { estatus: "ERROR", mensaje: err?.message || "Error al registrar salida por estudio" };
        }
    }

    async getHistorialMovimientos(idSucursal) {
        try {
            const url = idSucursal && idSucursal !== "todas"
                ? `${INVENTARIO_API_BASE_URL}/movimientos/${idSucursal}`
                : `${INVENTARIO_API_BASE_URL}/movimientos`;
            const res = await apiClient.get(url);
            if (res.data && res.data.movimientos) {
                return res.data;
            }
        } catch (err) {
            console.warn("Backend GET /inventarios/movimientos no disponible.", err?.message);
        }
        return { estatus: "OK", movimientos: [] };
    }

    async actualizarConsumo(payload) {
        // payload: { idArticuloN, idEstudioN, consumoN }
        try {
            const res = await apiClient.put(`${INVENTARIO_API_BASE_URL}/relacion/estudio`, payload);
            if (res.data) {
                return res.data;
            }
        } catch (err) {
            console.warn("Backend PUT /inventarios/relacion/estudio no disponible.", err?.message);
            return { estatus: "ERROR", mensaje: err?.message || "Error al actualizar consumo" };
        }
    }
}

export default new InventariosService();